<!--
 * @Author: chj
 * @Date: 2024-10-10 11:13:47
 * @LastEditors: chj
 * @LastEditTime: 2024-10-17 14:46:44
 * @Description: 请填写简介
-->
<template>
  <div id="app">
    <app-header />
    <router-view :key="$route.fullPath" />
    <app-footer />
    <back-to-top />
  </div>
</template>

<script>
import AOS from "aos";
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import BackToTop from "./components/BackToTop.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    BackToTop,
  },
  mounted() {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      once: false,
      mirror: false,
      delay: 100,
      duration: 1000,
    });
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
}
</style>
